export const ConfigureShippingMethod = {
    syncShippingZones: 'syncShippingZones',
    createCheckoutPlusScript: 'createCheckoutPlusScript',
    deleteCheckoutPlusScript: 'deleteCheckoutPlusScript',
    checkoutPlusProducts: 'checkoutPlusProducts',
    bulkUpdateDiscounts: 'bulkUpdateDiscounts',
};
//# sourceMappingURL=configure.js.map